/// <summary>
/// 缓存数据管理类
/// </summary>

import {EData} from "./EData";
import {KitTrack} from "./KitTrack";
import {SpStore} from "./SpStore";
import {KitSp} from "../KitSp";
import KitLog from "../KitLog";
import {KitEvent} from "@/Fwk/Kit/Track/KitEvent";

/// <author>xiexingwu</author>
export class CacheManager {
    private static SRC_112 = 112;
    private static SRC_113 = 113;
    private static SRC_216 = 216;
    private static SRC_217 = 217;
    private static SRC_218 = 218;
    private static SRC_219 = 219;
    private static SRC_511 = 511;
    private static SRC_512 = 512;
    private static SRC_513 = 513;

    public static FILE_K = 1000000;
    private static _loadedFileCache = false;
    private static _cache: Map<number, EData> = new Map<number, EData>();

    private static readonly _store = new SpStore();

    //需要异步
    static submit(event: KitEvent) {
        KitTrack._task.AddOneTime(() => this.Save(event), "");
    }

    private static Save(ev: KitEvent) {
        const type = this.GetType(ev);
        const data = new EData(this.GetLastEventId(), type, ev.toString());
        this._cache.set(data.BuildIndexName(), data);
        if (KitLog.IsLog) KitTrack.Log(`insert：${data.GetText()}`);
        this.WriteStore(data);
    }

    private static GetType(ev: KitEvent): number {
        switch (ev._src) {
            case this.SRC_112:
            case this.SRC_113:
                return KitTrack.SRC_TYPE_NOW;
            case this.SRC_216:
            case this.SRC_217:
            case this.SRC_218:
            case this.SRC_219:
            case this.SRC_511:
            case this.SRC_513:
                return KitTrack.SRC_TYPE_COM;
            case this.SRC_512:
                return KitTrack.SRC_TYPE_DELAY;
            default:
                return KitTrack.SRC_TYPE_COM;
        }
    }

    private static GetLastEventId(): number {
        let last = KitSp.GetInt("kit_track_id", 0);
        last++;
        if (last >= CacheManager.FILE_K) {
            //几乎不可能，重新从100开始，若有本地未上传统计文件，将会覆盖，若无，则回滚ID继续统计，无任何影响-by武爷
            last = 100;
        }

        KitSp.SetInt("kit_track_id", last);
        KitSp.Apply();
        return last;
    }

    static Remove(lastUpLoadData: EData[]) {
        if (lastUpLoadData == null || lastUpLoadData.length == 0) return;
        for (let eData of lastUpLoadData) {
            this._cache.delete(eData.BuildIndexName());
            this.RemoveStore(eData);
        }
    }

    private static UpdateFromFileCache() {
        if (this._loadedFileCache) return; //首次需要读取文件缓存
        const list = this._store.LoadAll();
        for (let eData of list) {
            if (!this._cache.has(eData.BuildIndexName())) {
                //内存里面没有的，才会放入内存缓存
                this._cache.set(eData.BuildIndexName(), eData);
            }
        }
        this._loadedFileCache = true;
    }

    static Summary(): [number, number] {
        this.UpdateFromFileCache();
        const allSize = this._cache.size;
        let firstType = KitTrack.SRC_TYPE_COM;

        let isNow:boolean = false;
        this._cache.forEach((eData,key) => {
            if (eData && eData.type == KitTrack.SRC_TYPE_NOW) {
                firstType = KitTrack.SRC_TYPE_NOW;
                isNow = true;
                return;
            }
        });
        if (isNow){
            return [firstType, allSize];
        }

        let isCom:boolean = false;
        this._cache.forEach((eData,key) => {
            if (eData && eData.type == KitTrack.SRC_TYPE_COM) {
                firstType = KitTrack.SRC_TYPE_COM;
                return;
            }
        })
        if (isCom){
            return [firstType, allSize];
        }
        firstType = KitTrack.SRC_TYPE_DELAY;
        return [firstType, allSize];
    }

    public static GetUploadDataList(maxSize: number = 40): EData[] {
        this.UpdateFromFileCache();

        const upList: EData[] = [];

        this._cache.forEach((item,key) => {
            const eData = item;
            if (!eData) return;
            upList.push(eData);
        })

        //找出优先级高的数据
        const items = upList.sort(item => item.BuildIndexName());
        return items.slice(0, maxSize);
    }

    private static RemoveStore(eData: EData) {
        this._store.Remove(eData);
    }

    public static ReadStore(data: EData) {
        this._store.Read(data);
    }

    private static WriteStore(data: EData) {
        this._store.Write(data);
    }
}